import Vue from 'vue';
import VueRouter from 'vue-router';

// Routes
import { canNavigate } from '@/libs/acl/routeProtection';

import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
} from '@/auth/utils';
import apps from './routes/apps';
import menus from './routes/menus';
import errors from './routes/errors';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: '/', redirect: { name: 'home' } },
    ...apps,
    ...menus,
    ...errors,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
});

// console.log(process.env.BASE_URL);

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn();
  // console.log('isLoggedIn:', isLoggedIn, to);
  // console.log('canNavigate', canNavigate(to));
  if (!canNavigate(to)) {
    // console.log('canNavigate', canNavigate(to));
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' });

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' });
  }

  // console.log('canNavigate');
  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData();
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null));
  }

  return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

export default router;
